
export class OutputSetCommand
{
    constructor(
        public Name: string,
        public State: number) 
    { }
}
